import React from 'react';
import { Stepper as BasisStepper } from 'basis';
import { byCountry, isDJ, isNZ } from 'utils';

import styled from '@emotion/styled';

const StyledStepper = styled.div`
  div[data-testid='stepper'] > div > div > div > div:nth-child(2) strong {
    color: ${isDJ() ? 'inherit' : 'white'};
  }

  div[data-testid='stepper'] p {
    font-family: 'Latitude Sans', sans-serif;
    color: ${isDJ() ? 'black' : '#0B2374'};

    & strong {
      font-weight: 600;
    }
  }
`;

export function ProgressStepper({ progress }) {
  const Stepper = byCountry({
    NZ: NZV2ProgressStepper,
    AU: AUProgressStepper,
  });
  return (
    <StyledStepper>
      <Stepper progress={progress} />
    </StyledStepper>
  );
}

function AUProgressStepper({ progress }) {
  return (
    <BasisStepper testId="stepper">
      <BasisStepper.Item label="Application" current={progress === 'Work'} />
      <BasisStepper.Item label-md="Additional verification" label="Checks" current={progress === 'Debts'} />
      <BasisStepper.Item label="Outcome" current={progress === 'Outcome'} />
    </BasisStepper>
  );
}

function NZV2ProgressStepper({ progress }) {
  return (
    <BasisStepper testId="stepper">
      <BasisStepper.Item label-md="Login" current={progress === 'You'} />
      <BasisStepper.Item label-md="Upload" current={progress === 'Debts'} />
      <BasisStepper.Item label="Outcome" current={progress === 'Outcome'} />
    </BasisStepper>
  );
}

ProgressStepper.ID = 'FixedStepperAndPageTitle';
ProgressStepper.HEIGHT_MAP = {
  default: BasisStepper.HEIGHT_MAP.default,
};
